exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FilterSectionLoader__skeletonLoader___2hF99 div {\n  background: linear-gradient(to right, rgba(255, 255, 255, 0), #f7f7f7 50%, rgba(255, 255, 255, 0) 80%), #f3f3f3;\n  background-repeat: repeat-y;\n  background-size: 50px 100%;\n  background-position: 0 0;\n  animation: FilterSectionLoader__shine___2gUOV 1s infinite; }\n\n@keyframes FilterSectionLoader__shine___2gUOV {\n  to {\n    background-position: 100% 0; } }\n\n.FilterSectionLoader__topBar___2r1hc {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 25px 17px;\n  height: 60px; }\n\n.FilterSectionLoader__heading___1AtXD {\n  height: 27px;\n  width: 92px; }\n\n.FilterSectionLoader__cross___1lRA6 {\n  height: 16px;\n  width: 16px; }\n\n.FilterSectionLoader__title___1j9Sf {\n  margin: 0 25px 16px;\n  height: 15px;\n  width: 100px; }\n\n.FilterSectionLoader__box___30lJ3 {\n  margin: auto 25px 15px;\n  height: 54px; }\n", ""]);

// exports
exports.locals = {
	"skeletonLoader": "FilterSectionLoader__skeletonLoader___2hF99",
	"shine": "FilterSectionLoader__shine___2gUOV",
	"topBar": "FilterSectionLoader__topBar___2r1hc",
	"heading": "FilterSectionLoader__heading___1AtXD",
	"cross": "FilterSectionLoader__cross___1lRA6",
	"title": "FilterSectionLoader__title___1j9Sf",
	"box": "FilterSectionLoader__box___30lJ3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/SearchPage/FilterSectionLoader/FilterSectionLoader.scss
// module id = 4261
// module chunks = 6